import { render, staticRenderFns } from "./CosignBeforeYouBegin.vue?vue&type=template&id=07534b00&"
import script from "./CosignBeforeYouBegin.vue?vue&type=script&lang=js&"
export * from "./CosignBeforeYouBegin.vue?vue&type=script&lang=js&"
import style0 from "./CosignBeforeYouBegin.vue?vue&type=style&index=0&id=07534b00&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports